import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { api, ApiHttpError } from '~/lib/api/client'
import type { RangeSnapshot } from '~/lib/api/types'

export const RANGE_QUERY_KEY = (from: string, to: string, tz: string) =>
  ['snapshot', 'range', from, to, tz] as const

export function useRangeSnapshot(from: string, to: string, tz: string) {
  return useQuery<RangeSnapshot, ApiHttpError>({
    queryKey: RANGE_QUERY_KEY(from, to, tz),
    queryFn: () => api.getSnapshotRange(from, to, tz),
    refetchOnWindowFocus: true,
    staleTime: 30 * 1000,
  })
}

export function useInvalidateRange() {
  const qc = useQueryClient()
  return useCallback(
    (from: string, to: string, tz: string) => {
      qc.invalidateQueries({ queryKey: RANGE_QUERY_KEY(from, to, tz) })
    },
    [qc]
  )
}
